import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    header:
      'heading-xs text-secondary-hover flex items-center justify-between gap-10',
    authorInfo: 'grow overflow-hidden overflow-ellipsis whitespace-nowrap',
    content: 'mt-3',
    question: 'heading-s-bold line-clamp-3 h-18',
    answerContainer: 'mt-5',
    answerHeader: 'heading-xs-bold flex items-center gap-3',
    answerText: 'heading-xs mt-3 line-clamp-3'
  }
});
